export const LOGOUT = 'LOGOUT';
export const VERIFY_AUTH = 'VERIFY_AUTH';
export const AUTHENTICATE = 'AUTHENTICATE';
export const GET_PROFILE = 'GET_PROFILE';
export const GENERATE_SUBSCRIPTION = 'GENERATE_SUBSCRIPTION';
